import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {l} from "../../types/typescriptdefinisjoner_lederplan";

export function benyttetAutentiseringsmetodeForInjisering() {
    return [regNavn.gettext.gettextCatalog, benyttetAutentiseringsmetode];
}

function benyttetAutentiseringsmetode(gettextCatalog: gettextCatalog): Function {
    return function (metode: l.BenyttetAutentiseringsmetode) {
        return benyttetAutentiseringsmetodeSomStreng(metode, gettextCatalog);
    };
}

export function benyttetAutentiseringsmetodeSomStreng(metode: l.BenyttetAutentiseringsmetode, gettextCatalog: gettextCatalog): string {
    if (isNaN(Number(metode))) return <any>metode;
    switch (Number(metode)){
        case l.BenyttetAutentiseringsmetode.passord: return gettextCatalog.getString('brukernavn og passord');
        case l.BenyttetAutentiseringsmetode.sms: return gettextCatalog.getString('tofaktor med sms');
        case l.BenyttetAutentiseringsmetode.totp: return gettextCatalog.getString('tofaktor med kodegenerator');
        case l.BenyttetAutentiseringsmetode.totpReserverkode: return gettextCatalog.getString('tofaktor med reservekoder');
        case l.BenyttetAutentiseringsmetode.bankidNorsk: return gettextCatalog.getString('Norsk BankID');
        case l.BenyttetAutentiseringsmetode.bankidSvensk: return gettextCatalog.getString('Svensk BankID');
        default: return l.BenyttetAutentiseringsmetode[metode];
    }
}
